// frontend/src/services/veloceService.ts
// Connexion à la caisse Véloce Cloud : statut, test, enregistrement des
// identifiants (chiffrés côté serveur, jamais renvoyés), vérification réelle.

import api from './api';

export type VeloceCredentialSource = 'location' | 'global' | 'env';
export type VeloceCheckStatus = 'CONNECTED' | 'FAILED' | 'UNKNOWN';

export interface VeloceConnectionStatus {
  configured: boolean;
  source: VeloceCredentialSource | null;
  email: string | null;
  baseUrl: string | null;
  /** Dernière vérification réelle réussie et récente (24 h). */
  connected: boolean;
  lastStatus: VeloceCheckStatus;
  lastCheckedAt: string | null;
  lastError: string | null;
  lastSync: { type: string; completedAt: string | null; itemsProcessed: number } | null;
}

export interface VeloceCredentialsInput {
  email: string;
  password: string;
  baseUrl?: string;
  /** 'location' = cet emplacement seulement ; 'global' = repli pour toute l'installation. */
  scope?: 'location' | 'global';
}

export interface VeloceTestResult {
  ok: boolean;
  message: string;
  locationsFound?: number;
  locations?: Array<{ id: string; name: string }>;
}

export async function fetchVeloceStatus(): Promise<VeloceConnectionStatus> {
  const response = await api.get('/veloce/status');
  return response.data.data as VeloceConnectionStatus;
}

/** Teste des identifiants sans les enregistrer. */
export async function testVeloceConnection(input: VeloceCredentialsInput): Promise<VeloceTestResult> {
  const response = await api.post('/veloce/test', input);
  return response.data.data as VeloceTestResult;
}

/** Vérifie puis enregistre les identifiants (chiffrés) pour la portée choisie. */
export async function connectVeloce(input: VeloceCredentialsInput): Promise<VeloceConnectionStatus> {
  const response = await api.post('/veloce/connect', input);
  return response.data.data as VeloceConnectionStatus;
}

export async function disconnectVeloce(scope: 'location' | 'global' = 'location'): Promise<void> {
  await api.post('/veloce/disconnect', { scope });
}

/** Vérification réelle auprès de l'API avec les identifiants enregistrés. */
export async function checkVeloceConnection(): Promise<VeloceConnectionStatus> {
  const response = await api.post('/veloce/check');
  return response.data.data as VeloceConnectionStatus;
}
